var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEapRectangle(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 17,
    viewBox: "0 0 10 17",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.94903 16.6667H10V16.6057C10 16.6453 9.97373 16.6665 9.94903 16.6667ZM10 0.0497683V0L9.99846 0.0385707C9.99293 0.0183107 9.97316 0 9.9487 0H0.051301C0.0400198 0 0.026367 0.00497905 0.0156086 0.015025C0.00861356 0.0215568 0.00380031 0.0292734 0.00151631 0.0379078L0 0V0.0497683C0 0.0456535 0.00051519 0.0416925 0.00151631 0.0379078L0.666667 16.6667H9.33333L9.99846 0.0385707C9.99947 0.0422714 10 0.0460372 10 0.0497683ZM0 16.6667V16.6169C0 16.641 0.022182 16.6665 0.0509479 16.6667H0ZM3.48091 14.2517H6.50821C6.74369 14.2517 6.9455 14.0499 6.9455 13.8145C6.9455 13.5792 6.74369 13.3774 6.50821 13.3774H3.48091C3.24543 13.3774 3.04362 13.5792 3.04362 13.8145C3.04362 14.0499 3.24543 14.2517 3.48091 14.2517Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEapRectangle);
export default __webpack_public_path__ + "static/media/eap-rectangle.9fa07d141dc0c14911616a06e8a9d356.svg";
export { ForwardRef as ReactComponent };